import {createUser} from './user';
import {FETCH_NEW_TOKEN, FETCH_TOKEN, LOGOUT} from '../constants/auth';
import {createStudent, fetchStudentData} from './student';

export function fetchToken(creds) {
  return ({
    type: FETCH_TOKEN,
    api: true,
    payload: {
      method: 'POST',
      url: '/auth/login',
      data: creds
    }
  });
}

export function loginUser(creds) {
  return async function (dispatch) {
    const {error} = await dispatch(fetchToken(creds));
    if (!error) await dispatch(fetchStudentData());
  };
}

export function fetchNewToken(refresh_token) {
  return ({
    type: FETCH_NEW_TOKEN,
    api: true,
    payload: {
      method: 'POST',
      url: '/auth/refresh',
      data: {refresh: refresh_token}
    }
  });
}

function requestLogout() {
  return ({type: LOGOUT});
}

export function logoutUser(history = null) {
  return function (dispatch) {
    dispatch(requestLogout());
    if (history) history.push('/login');
  };
}

export function registerUser(data) {
  return async function (dispatch) {
    const {mobile, authKey, firstName, lastName, gender, password, ...studentData} = data;
    let {error} = await dispatch(createUser({mobile, authKey, firstName, lastName, gender, password}));
    if (!error) await dispatch(createStudent(studentData));
    if (!error) await dispatch(fetchToken({mobile, password}));
  };
}
